import React from 'react';
import styled from 'styled-components';

import { CounterPluralize } from '@lt/components/components/CounterPluralize';

import type { INightsPicker } from './types';
import {
  MIN_NIGHTS_COUNT_HOTEL,
  MIN_NIGHTS_COUNT_PACKAGE,
  MAX_NIGHTS_COUNT,
} from '../../constants';

export const NightsPicker = (props: INightsPicker): JSX.Element => {
  const { selectedNightsCount, handleSelect, isHotelOnly } = props;
  const { from, to } = selectedNightsCount;

  const baseMinValue = isHotelOnly ? MIN_NIGHTS_COUNT_HOTEL : MIN_NIGHTS_COUNT_PACKAGE;

  return (
    <NightsControlsContainer>
      От
      <StyledCounterPluralize
        value={from}
        minValue={baseMinValue}
        maxValue={to}
        onChange={(newValue: number) => {
          handleSelect({ from: newValue, to });
        }}
      />
      до
      <StyledCounterPluralize
        value={to}
        minValue={from}
        maxValue={MAX_NIGHTS_COUNT}
        onChange={(newValue: number) => {
          handleSelect({ from, to: newValue });
        }}
      />
      ночей
    </NightsControlsContainer>
  );
};

const NightsControlsContainer = styled.div`
  width: 290px;
  margin: 29px 0 21px;

  display: flex;
  justify-content: space-around;
  align-items: center;

  color: #4d4d4d;
`;

const StyledCounterPluralize = styled(CounterPluralize)`
  font-weight: 700;

  & button:disabled {
    border-color: #c2c5cc;
  }

  && button:disabled i::before {
    background-color: #c2c5cc;
  }
`;
